(ns admin.core
  (:require [reagent.dom :as reagent-dom]
            [re-frame.core :as re-frame]
            [re-frame-notifier.core :refer [render-notifications]]

            [kyber.feature-flags :refer [feature-enabled?]]
            [kyber.lib.polyfill]
            [kyber.shims]
            [kyber.components.composite.tooltip :as tooltip]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.composite.loading :as loading]
            [admin.router.core :as router]
            [admin.components.composite.no-admin-access :as no-admin-access]
            ;; Register the following namespaces
            [admin.db.core]
            [admin.events.core]
            [admin.subscriptions.core]))

(def styles
  {:page-container
   {:display :flex
    :flex-direction :column
    :justify-content :center
    :min-height "100%"
    (gs [:queries :ie])
    {:height 0}}})

(def classes (styles->classes styles))

;; Open routes are routes that any authenticated user can view that DO NOT
;; require the admin app access flag to be set to true. This is being used
;; today to allow managers into the app to access their dashboards.
;; NOTE: This will proboably need to be reworked when roles & authentication
;;       is revisited.
(def open-routes #{:learner-reports-activity
                   :learner-reports-activity-learner
                   :curriculum-learner-reports-index})

(defn- core-container
  []
  (let [is-bootstrapped
        (re-frame/subscribe [:bootstrap/finished?])

        authenticated
        (re-frame/subscribe [:authentication/is-authenticated?])

        has-admin-app-access
        (re-frame/subscribe [:authentication/has-access?
                             :admin-app/can-view])
        has-permissions
        (re-frame/subscribe
         [:authentication/has-permissions?])

        route
        (re-frame/subscribe [:router/route])]
    (fn []
      (let [has-access-to-requested-content (or @has-admin-app-access
                                                (some? (open-routes @route)))]
        (cond
          (and (true? @is-bootstrapped)
               ;; If they are unauthenticated allow them to pass through,
               ;; they will be redirected
               (or (false? @authenticated)
                   (true? has-access-to-requested-content)))
          [:div {:class (:page-container classes)
                 :style {:background-color (gs [:colors :gray-scale-100])}}
           [router/router {:is-bootstrapped @is-bootstrapped
                           :has-admin-access @has-admin-app-access
                           :is-authenticated @authenticated}]
           [tooltip/render]
           [render-notifications]]

          (and (true? @is-bootstrapped)
               (true? @authenticated)
               (true? @has-permissions)
               (false? has-access-to-requested-content))
          [no-admin-access/render {:should-sign-out? true}]

          :else
          [loading/render {:is-bootstrapped @is-bootstrapped
                           :fixed? true
                           :show-logo true}])))))

(defn ^:dev/after-load mount-root
  "Entry point for Kyber Admin"
  []
  (reagent-dom/render [core-container]
                      (js/document.getElementById "app")))

(defn init
  []
  (when (feature-enabled? :console-log)
    (js/console.log "Hello 👋!"))
  (re-frame/dispatch [:bootstrap/start])
  (mount-root))
